export default __webpack_public_path__ + "static/media/630bc62dd27da37b2add78924c0face4.svg";